import { render, staticRenderFns } from "./KriminalitasDetail.vue?vue&type=template&id=0aea7230&scoped=true"
import script from "./KriminalitasDetail.vue?vue&type=script&lang=js"
export * from "./KriminalitasDetail.vue?vue&type=script&lang=js"
import style0 from "./KriminalitasDetail.vue?vue&type=style&index=0&id=0aea7230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea7230",
  null
  
)

export default component.exports